<bw-header-label-cell-legacy
  @fadeIn
  (clickEvent)="navigateToCashAdvanceDashboard()"
  [labelCellConfig]="cashAdvanceCellConfig"
  [hasContent]="showRetryAccessory"
>
  @if (showRetryAccessory) {
  <bw-bui-tile-legacy tileMargin="0 0 8px 0">
    <bui-tile-card-legacy (click)="retryCashAdvance()" [cardBackground]="'var(--white)'" [cardBorder]="'1px solid var(--gray-10)'">
      <bw-bui-row-legacy [rightIconName]="'refresh'" rightIconColor="var(--secondary-text)">
        <div class="row-content">
          <bw-bui-column-legacy
            [rowSpacing]="4"
            [rows]="[
              { type: 'detail', content: 'ACCOUNT_ERROR_TITLE' | translate, color: 'var(--primary-text)' },
              { type: 'label', content: 'ACCOUNT_ERROR_DESC' | translate, color: 'var(--secondary-text)' }
            ]"
          ></bw-bui-column-legacy>
        </div>
      </bw-bui-row-legacy>
    </bui-tile-card-legacy>
  </bw-bui-tile-legacy>
  }
</bw-header-label-cell-legacy>
